/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { loadCSS } from 'fg-loadcss';
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import clsx from 'clsx';

import Datetime from 'react-datetime';
import { red } from '@material-ui/core/colors';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardAvatar from "components/Card/CardAvatar.js";
import avatar from "assets/img/faces/marc.jpg";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';

import TSSelect from "components/Forms/TSSelect";
import TSSelect2 from "components/Forms/TSSelect2";
import TSCheckBox from "components/Forms/TSCheckBox";
import TSRadio from "components/Forms/TSRadio";
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import TSUser from "components/Forms/TSUser"; 
import TSText from "components/Forms/TSText";
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal, ModalBody 
} from "reactstrap";

import axios from "axios";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {

};

const primaryColor = "#af2cc5";

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
    flexGrow: 1,
  },
  cardTitle: {
    textAlign: 'center'
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    flexGrow: 1,
  },
  collaps:{
    paddingLeft:'40px', 
    paddingTop:'40px',    
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    ...StyleSheet.absoluteFillObject,
    alignSelf: 'flex-end',
    position: 'absolute', // add if dont work with above
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}


const Employee = (props) => {
  var moment = require('moment');
  require('moment/locale/th');
  const [tabValue, setTabValue] = React.useState(0);
  const [MeetingKey, setMeetingKey] = useState(null);
  const [MeetingName, setMeetingName] = useState("");
  const [MeetingTypeKey, setMeetingTypeKey] = useState(null);
  const [IsUrgent, setIsUrgent] = useState(false);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [StartType, setStartType] = useState("");

  const [UserDept, setUserDept] = useState([]);
  const [UserEducation, setUserEducation] = useState([]);

  const [UserID, setUserID] = useState("");
  const [TitleName, setTitleName] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [NickName, setNickName] = useState("");
  const [Badgenumber, setBadgenumber] = useState("");
  const [Cid, setCid] = useState("");
  const [BirthDT, setBirthDT] = useState("");

  const [Email, setEmail] = useState("");
  const [Gmail, setGmail] = useState("");
  const [GenderKey, setGenderKey] = useState(0);
  const [TypeGovKey, setTypeGovKey] = useState(0);
  const [PositionName, setPositionName] = useState("");
  
  const [Address, setAddress] = useState("");
  const [Photo, setPhoto] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [IsActive, setIsActive] = useState(0);
  const [IsDefault, setIsDefault] = useState(false);
  const [IsShowBirthdate, setIsShowBirthdate] = useState(0);
  const [LineNotify, setLineNotify] = useState("");
  const [LineToken, setLineToken] = useState("");





  const [UserDepartmentKey, setUserDepartmentKey] = useState(0);
  const [DepartmentKey, setDepartmentKey] = useState(0);
  const [DepartmentTypeKey, setDepartmentTypeKey] = useState(0);
  const [UserLevelKey, setUserLevelKey] = useState(0);
  const [UserName, setUserName] = useState('');

  const [ArrDepartment, setArrDepartment] = useState([]);
  const [ArrDepartmentType, setArrDepartmentType] = useState([]);
  const [ArrUserLevel, setArrUserLevel] = useState([]);

    const [ArrTypeGov, setArrTypeGov] = useState([]);
    const [ArrHip, setArrHip] = useState([]);



  const [IsMoreDate, setIsMoreDate] = useState(false);
  const [EndType, setEndType] = useState("");
  const [MeetingDescription, setMeetingDescription] = useState('');

  const [ContactAddress, setContactAddress] = useState('');
  const [ContactPhone, setContactPhone] = useState('');

  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [currentDate, setcurrentDate] = useState(moment());
  const [holidays, setHolidays] = useState([]);
  const [Attendee, setAttendee] = useState([]);
  const [emp, setEmp] = useState(null);

  const [toggleType, setToggleType] = useState('');
  const [toggleEducationType, setToggleEducationType] = useState('');
  const [toggleEdit, setToggleEdit] = useState(false);
  const [toggleNew, setToggleNew] = useState(false);

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");

  const [expanded, setExpanded] = React.useState(true);


  const [isOpen, setIsOpen] = useState(false);
  const [dateFocus, setDateFocus] = useState(false);

  const [TopicName, setTopicName] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");
  const [PlaceName, setPlaceName] = useState("");
  const [DurationNote, setDurationNote] = useState("");
  const [Note, setNote] = useState("");
  const [EmployeeKey, setEmployeeKey] = useState("");
  const [EmpEducationOtherKey, setEmpEducationOtherKey] = useState("");

  const isActiveList = [{ label:"ใช้งานอยู่", value:true}, { label:"ปิดการใช้งาน", value:false} ];
  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];
  const dateTypeList = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} , { label:"ครึ่งวันบ่าย", value:2}];
  const genderList = [{ label:"ชาย", value:1}, { label:"หญิง", value:2}];

  const myRef = useRef(null);


  useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v6.3.0/css/all.css',
      document.querySelector('#font-awesome-css'),
    );



    axios.get("/api/v1/typegov")
    .then(
      result => {
          if(result.data.result == 200)
          {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"typeGovKey":').join('"value":'));
            setArrTypeGov(json)
          }
        },
        error => {console.log(error); }
    );  


    axios.get("/api/v1/userlevel")
    .then(
      result => {
          if(result.data.result == 200)
          {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"userLevelKey":').join('"value":'));
            setArrUserLevel(json)
          }
        },
        error => {console.log(error); }
    );  


    axios.get("/api/v1/departmenttype")
    .then(
      result => {
          if(result.data.result == 200)
          {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"departmentTypeKey":').join('"value":'));
            setArrDepartmentType(json)
          }
        },
        error => {console.log(error); }
    );  


    axios.get("/api/v1/department")
    .then(
      result => {
          if(result.data.result == 200)
          {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"departmentKey":').join('"value":'));
            setArrDepartment(json)
          }
        },
        error => {console.log(error); }
      );  

      axios.get("/api/v1/userhip")
          .then(
              result => {
                  if (result.data.result == 200) {
                      var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"badgenumber":').join('"value":'));
                      setArrHip(json)
                  }
              },
              error => { console.log(error); }
          ); 

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);







  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

  };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };


  const handleEmpData = (_val) => {
      //setExpanded(false);
      setToggleType('');
      //setToggleEdit(false);
      //setToggleNew(false);
    setEmp(_val[0]);
   

    if(_val != null && _val.length > 0)
    {
       var v = _val[0];

       console.log(v)

       setUserName(v.userName)
       setUserID(v.userID)
       setTitleName(v.titleName)
       setFirstName(v.firstName)
       setLastName(v.lastName)
       setNickName(v.nickName)
       setCid(v.cid)
       setGenderKey(v.genderKey)
       setBirthDT(v.birthDT)
       setMobilePhone(v.mobilePhone)
       setEmail(v.email)
       setGmail(v.gmail)
       setAddress(v.address)
       setTypeGovKey(v.typeGovKey)
       setLineNotify(v.lineNotify)
       setLineToken(v.lineToken)
       setPhoto(v.photo)
       setIsShowBirthdate(v.isShowBirthdate)
       setIsActive(v.isActive)
       setPositionName(v.positionName)
       setBadgenumber(v.badgenumber)

        axios.get("/api/v1/userdepartment/"+v.userID)
        .then(
          result => {
              if(result.data.result == 200)
              {
                console.log(result.data.data);
                setUserDept(result.data.data)
              }
            },
            error => {console.log(error); }
        ); 
        
         axios.get("/api/v1/empEducation/" + v.cid)
        .then(
          result => {
              if(result.data.result == 200)
              {
                setUserEducation(result.data.data[0].empEducationOther)
                setEmployeeKey(result.data.data[0].employeeKey)
              }
            },
            error => {console.log(error); }
        );  
       
     }


 };


  
  const editUser = () => {

     var usr = { 
      titleName: TitleName,
      firstName: FirstName,
      lastName: LastName,
      nickName: NickName,
      cid: Cid,
      birthDT: BirthDT,
      isShowBirthdate: IsShowBirthdate,
      genderKey: GenderKey,
      typeGovKey: TypeGovKey,
      positionName: PositionName,
      email: Email,
      gmail: Gmail,
      lineNotify: LineNotify,
      lineToken: LineToken,
      photo: Photo,
      address: Address,
      mobilePhone: MobilePhone,
      badgenumber: Badgenumber,
      isActive: IsActive,
    };



    axios.put("/api/v1/user/"+UserID, usr)
    .then(
      result => {
          if(result.data.result == 200)
          {
            alert('บันทึกสำเร็จ')
            setEmp(null)
          }
        },
        error => {console.log(error); }
    );  



  };

  const newUserDepartment = () => {

        var usrDept = { departmentTypeKey: DepartmentTypeKey, departmentKey: DepartmentKey, userLevelKey: UserLevelKey, userName: UserName, isDefault: IsDefault };

      if (DepartmentTypeKey == 0)
          alert('กรุณาระบุประเภทโครงสร้าง')
      else if (DepartmentKey == 0)
          alert('กรุณาระบุหน่วยงาน')
      else if (UserLevelKey == 0)
          alert('กรุณาระบุระดับ')
      else {
          axios.post("/api/v1/userdepartment", usrDept)
              .then(
                  result => {
                      if (result.data.result == 200) {
                          alert('บันทึกสำเร็จ')

                          axios.get("/api/v1/userdepartment/" + UserID)
                              .then(
                                  result => {
                                      if (result.data.result == 200) {
                                          setUserDept(result.data.data)
                                          //setToggleEdit(false)
                                          //setToggleNew(false)
                                          setToggleType('')
                                      }
                                  },
                                  error => { console.log(error); }
                              );
                      }
                  },
                  error => { console.log(error); }
              ); 
      }

        /*
        
            */
    };
  const editUserDepartment = () => {
    
    
    var usrDept = { departmentTypeKey: DepartmentTypeKey, departmentKey:DepartmentKey, userLevelKey:UserLevelKey, userName:UserName, isDefault: IsDefault };
    axios.put("/api/v1/userdepartment/"+UserDepartmentKey, usrDept)
    .then(
      result => {
          if(result.data.result == 200)
          {
            alert('บันทึกสำเร็จ')

            axios.get("/api/v1/userdepartment/"+UserID)
            .then(
              result => {
                  if(result.data.result == 200)
                  {
                      setUserDept(result.data.data)
                      //setToggleEdit(false)
                      //setToggleNew(false)
                      setToggleType('')
                  }
                },
                error => {console.log(error); }
            );  
        
            
          }
        },
        error => {console.log(error); }
    );  


  };

  const deleteUserDepartment = () => {
    if (window.confirm("คุณต้องการลบข้อมูลต้นสังกัดนี้ใช่หรือไม่?")) {
      axios.delete("/api/v1/userdepartment/" + UserDepartmentKey)
        .then(
          result => {
            if (result.data.result == 200) {
              alert('ลบสำเร็จ');
              axios.get("/api/v1/userdepartment/" + UserID)
                .then(
                  result => {
                    if (result.data.result == 200) {
                      setUserDept(result.data.data);
                      setToggleType('');
                    }
                  },
                  error => { console.log(error); }
                );
            } else {
              alert(result.data.msg || 'ไม่สามารถลบได้');
            }
          },
          error => { console.log(error); alert('เกิดข้อผิดพลาดในการลบ'); }
        );
    }
  };

  const handleDeleteUserDepartmentDirect = (key) => (e) => {
    if (e) e.stopPropagation();
    if (window.confirm("คุณต้องการลบข้อมูลต้นสังกัดนี้ใช่หรือไม่?")) {
      axios.delete("/api/v1/userdepartment/" + key)
        .then(
          result => {
            if (result.data.result == 200) {
              alert('ลบสำเร็จ');
              axios.get("/api/v1/userdepartment/" + UserID)
                .then(
                  result => {
                    if (result.data.result == 200) {
                      setUserDept(result.data.data);
                      setToggleType('');
                    }
                  },
                  error => { console.log(error); }
                );
            } else {
              alert(result.data.msg || 'ไม่สามารถลบได้');
            }
          },
          error => { console.log(error); alert('เกิดข้อผิดพลาดในการลบ'); }
        );
    }
  };

  const handleUserDepartment = (userDepartmentKey, departmentTypeKey, departmentKey, userLevelKey, userName, isDefault) => (e) => {

    setUserDepartmentKey(userDepartmentKey)
    setDepartmentTypeKey(departmentTypeKey)
    setDepartmentKey(departmentKey)
    setUserLevelKey(userLevelKey)
    setUserName(userName)
    setIsDefault(isDefault)

      setToggleType('edit')
      //setToggleEdit(true);
      //setToggleNew(false);
 };
    
    const handleEditEducation = (toDate, endDate, topicName, organizationName, placeName, durationNote, note, empEducationOtherKey) => (e) => {

    setStartDate(toDate)
    setEndDate(endDate)
    setTopicName(topicName)
    setOrganizationName(organizationName)
    setPlaceName(placeName)
    setDurationNote(durationNote)
    setNote(note)
    setEmpEducationOtherKey(empEducationOtherKey)
    setToggleEducationType('edit')
 };


    const handleNewUserDepartment = (userName) => (e) => {

        setUserDepartmentKey('')
        setDepartmentTypeKey('')
        setDepartmentKey('')
        setUserLevelKey('')
        setUserName(userName)
        setIsDefault(false)
        setToggleType('new')
        //setToggleNew(true);
        //setToggleEdit(false);
    };

    const editEducation = () => {
     if (StartDate == '')
          alert('กรุณาระบุวันที่เริ่มต้น')
      else if (EndDate == '')
          alert('กรุณาระบุวันที่สิ้นสุด')
      else if (TopicName == '')
          alert('กรุณาระบุชื่อหลักสูตร')
      else if (OrganizationName == '')
          alert('กรุณาระบุหน่วยงานที่จัด')
      else if (PlaceName == '')
          alert('กรุณาระบุสถาณที่')
      else if (DurationNote == '')
          alert('กรุณรระบบระยะเวลา')
      else {
            var edu = { 
              employeekey: EmployeeKey,
              fromDate: StartDate,
              todate: EndDate,
              topicName: TopicName,
              organizationName: OrganizationName,
              placeName: PlaceName,
              durationNote: DurationNote,
              note: Note,
              empEducationOtherKey: EmpEducationOtherKey,
            };

            axios.put("/api/v1/empEducation/" + EmpEducationOtherKey, edu)
            .then(
            result => {
            if(result.data.result == 200)
            {
              alert('บันทึกสำเร็จ')

              axios.get("/api/v1/empEducation/" + Cid)
              .then(
              result => {
                if(result.data.result == 200)
                {
                  setUserEducation(result.data.data[0].empEducationOther)
                  setEmployeeKey(result.data.data[0].employeeKey)
                }
              },
              error => {console.log(error); }
            );  
          }
        },
        error => {console.log(error); }
      );  
    }
  };

  const deleteEducation = () => {
            axios.delete("/api/v1/empEducation/" + EmpEducationOtherKey)
            .then(
            result => {
            var res = result.data;
              alert('ลบสำเร็จ')
              axios.get("/api/v1/empEducation/" + Cid)
              .then(
              result => {
                if(result.data.result == 200)
                {
                  setUserEducation(result.data.data[0].empEducationOther)
                  setEmployeeKey(result.data.data[0].employeeKey)
                  setToggleEducationType('')
                }
              },
              error => {console.log(error); }
            );  
        },
        error => {console.log(error); }
      );  
    }



  const saveNewEducation = () => {

      if (StartDate == '')
          alert('กรุณาระบุวันที่เริ่มต้น')
      else if (EndDate == '')
          alert('กรุณาระบุวันที่สิ้นสุด')
      else if (TopicName == '')
          alert('กรุณาระบุชื่อหลักสูตร')
      else if (OrganizationName == '')
          alert('กรุณาระบุหน่วยงานที่จัด')
      else if (PlaceName == '')
          alert('กรุณาระบุสถาณที่')
      else if (DurationNote == '')
          alert('กรุณรระบบระยะเวลา')
      else {
            var edu = { 
              employeekey: EmployeeKey,
              fromDate: StartDate,
              todate: EndDate,
              topicName: TopicName,
              organizationName: OrganizationName,
              placeName: PlaceName,
              durationNote: DurationNote,
              note: Note,
            };

           axios.post("/api/v1/empEducation", edu)
              .then(
                  result => {
                      if (result.data.result == 200) {
                          alert('บันทึกสำเร็จ')

                          axios.get("/api/v1/empEducation/" + Cid)
                          .then(
                          result => {
                            if(result.data.result == 200)
                            {
                              setUserEducation(result.data.data[0].empEducationOther)
                              setEmployeeKey(result.data.data[0].employeeKey)
                            }
                          },
                          error => {console.log(error); }
                        );  
                      }
                  },
                  error => { console.log(error); }
              ); 
      }
    };

  const handleNewEducation = (userName) => (e) => {
    setStartDate('')
    setEndDate('')
    setTopicName('')
    setOrganizationName('')
    setPlaceName('')
    setDurationNote('')
    setNote('')
    setToggleEducationType('new')
  };

  const handleStartDate = (date) => {
      setStartDate(date);
  }

  const handleEndDate = (date) => {
    setEndDate(date);
  } 

    const classes = useStyles();
    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                  <Card>
                        <CardHeader color="primary" style={{display:'flex', cursor:'pointer'}} onClick={handleExpandClick}>
                            <h4 className={classes.cardTitleWhite}>โครงสร้างภารกิจ</h4>
                            <p className={classes.cardCategoryWhite}> </p>
                          
                            <CardActions className={classes.collaps}>
                                <IconButton
                                  className={clsx(classes.expand, {
                                    [classes.expandOpen]: expanded,
                                  })}
                                  onClick={handleExpandClick}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                >
                                  <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                            
                        </CardHeader>
                        <CardBody>        
                        <Collapse in={expanded} timeout="auto" unmountOnExit>                  
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                 <TSUser value={Attendee} isMultiple={false} isShowAll={true} onChange={e => handleEmpData(e)} />
                                </Col>
                            </Grid>
                        </Collapse>  
                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                          {/* Confirm */}
                          <Modal toggle={() => setModal(false)} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการบันทึกข้อมูล"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>

                              <Button
                                color="primary"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>
                            </div>
                          </Modal>

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>
                      </CardFooter>
                  </Card>
                
                </Col>


               {emp != null ?
               <Col xs={12} sm={12} md={12}>

               <Card>
                     <CardAvatar profile>
                       <a href="#pablo" onClick={(e) => e.preventDefault()}>
                       <img src={'https://e.trangskin.go.th/avatar/'+emp.userName+'.jpg'} style={{width: 120, height: 120, borderRadius: 120/2, objectFit: 'cover', objectPosition: '100% 0'}} />
                       </a>      
                                         
                     </CardAvatar>
                     <CardBody profile>      
                       <h5 className={classes.cardTitle}> {emp != null ? emp.firstName+' '+emp.lastName:''}</h5>    
                       <h5 className={classes.cardTitle}> {UserName}</h5>    
                     <AppBar position="static" color="default">

                         <Tabs
                           value={tabValue}
                           onChange={handleTabChange}
                           variant="scrollable"
                           scrollButtons="on"
                           indicatorColor="primary"
                           textColor="primary"
                           aria-label="scrollable force tabs example"
                         >
                           <Tab label="ข้อมูลส่วนบุคคล" icon={<Icon className="fa fa-circle-info" />} {...a11yProps(0)} />
                           <Tab label="ต้นสังกัด" icon={<FavoriteIcon />} {...a11yProps(1)} />
                           <Tab label="ประวัติการอบรม/ดูงาน/สัมนา" icon={<PersonPinIcon />} {...a11yProps(2)} />
                           {/* 
                           <Tab label="Item Three" icon={<PersonPinIcon />} {...a11yProps(2)} />
                           <Tab label="Item Four" icon={<HelpIcon />} {...a11yProps(3)} />
                           <Tab label="Item Five" icon={<ShoppingBasket />} {...a11yProps(4)} />
                           <Tab label="Item Six" icon={<ThumbDown />} {...a11yProps(5)} />
                           <Tab label="Item Seven" icon={<ThumbUp />} {...a11yProps(6)} />
                           */}
                         </Tabs>
                       </AppBar>
                       <TabPanel value={tabValue} index={0}>       
                         <Grid>
           
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="คำนำหน้า" defaultValue={TitleName} value={TitleName} onChange={e => setTitleName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="ชื่อ" value={FirstName} onChange={e => setFirstName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="สกุล" value={LastName} onChange={e => setLastName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="ชื่อเล่น" value={NickName} onChange={e => setNickName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={4}  lg={4} xl={2} >
                               <TSText label="เลขบัตรประจำตัวประชาชน" value={Cid} onChange={e => setCid(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={4} lg={4} xl={2}>
                               <TSSelect2 fontSize='1em' label="เพศ" options={genderList} value={GenderKey} onChange={e => setGenderKey(e.value) } />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <Label>วันเดือนปีเกิด</Label>
                                  <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px' }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            //left: '30px',
                                            zIndex: 1,
                                          
                                        }}
                                        ></i>
                                          <Datetime
                                              value={moment(BirthDT).isValid() ? moment(BirthDT) : null}
                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              //isValidDate={isDateValid}
                                              //renderDay={renderDay}
                                              //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                              //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                              //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                              inputProps={{
                                                  name: "BirthDT", placeholder: "วันเดือนปีเกิด", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  }
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                              //timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => setBirthDT(e.format('YYYY-MM-DD'))}                                        
                                        />

                                        
                                    </FormGroup>
                                    <TSCheckBox checked={IsShowBirthdate} onChange={e => setIsShowBirthdate(!IsShowBirthdate) } /> {(IsShowBirthdate)? <span style={{ color: 'green' }} >แสดงวันเกิด </span>  :<span style={{ color: 'red' }}>ไม่แสดงวันเกิด </span>  }
                             </Col>

                             <Col xs={12} sm={6} md={4} lg={4} xl={3} >
                               <TSText label="โทรศัพท์" value={MobilePhone} onChange={e => setMobilePhone(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="Email" value={Email} onChange={e => setEmail(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="Gmail" value={Gmail} onChange={e => setGmail(e.target.value)} />
                             </Col>
                   
                             <Col xs={12} sm={12} md={12}>
                                 <div className="textarea-container" style={{ padding: 0 }}>
                                       <Label for="Address">ที่อยู่ </Label>  
                                           {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                       <Input
                                           id="Address"
                                           cols="80"
                                           name="Address"
                                           placeholder="ที่อยู่"
                                           rows="4"
                                           type="textarea"
                                           className="custom"
                                           style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                           value={Address}
                                           onChange={e => setAddress(e.target.value) }
                                           ></Input>
                                   </div>
                             </Col>
                             <Col xs={12} sm={6} md={6} lg={4} xl={2}>
                               <TSSelect2 fontSize='1em' label="ประเภทเจ้าหน้าที่" options={ArrTypeGov} value={TypeGovKey} onChange={e => setTypeGovKey(e.value) } />
                             </Col>
                             <Col xs={12} sm={6} md={6} lg={4} xl={2}>
                               <TSText label="ตำแหน่ง" value={PositionName} onChange={e => setPositionName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={12} md={12} lg={4} xl={2}>
                               <TSText label="รูป" value={Photo} onChange={e => setPhoto(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={6} lg={4} xl={2}>
                                <TSSelect2 fontSize='1em' label="ข้อมูลสแกนนิ้ว" options={ArrHip} value={Badgenumber} onChange={e => setBadgenumber(e.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={6} lg={4} xl={2}>
                               <TSText label="LineNotify" value={LineNotify} onChange={e => setLineNotify(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={6} lg={4} xl={2}>
                               <TSText label="LineBot" value={LineToken} onChange={e => setLineToken(e.target.value)} />
                             </Col>
            
                             <Col xs={12} sm={12} md={4}>
                                <TSCheckBox checked={IsActive} onChange={e => setIsActive(!IsActive) } />{(IsActive)? <span style={{ color: 'green' }} >เปิดการใช้งานอยู่ </span>  :<span style={{ color: 'red' }}>ปิดการใช้งานไปแล้ว </span>  }
                             </Col>      

                             <Col xs={12} sm={12} md={12} style={{textAlign:'center'}} >

                               <Button
                                 style={{maxWidth: '400px;'}}
                                 color="primary"
                                 type="button"
                                 onClick={editUser}
                                 disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                               >
                                 <h4>บันทึก</h4>
                               </Button>

                             </Col>
                         </Grid>

                       </TabPanel>
                       <TabPanel value={tabValue} index={1}>
                           {(toggleType == 'new') ?
                             <Grid>
                                            <Col xs={12} sm={12} md={2} lg={4}> &nbsp; </Col>
                                            <Col xs={12} sm={12} md={8} lg={4}>
                                                <Grid>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSSelect2 fontSize='0.9em' label="ประเภทโครงสร้าง" options={ArrDepartmentType} value={DepartmentTypeKey} onChange={e => setDepartmentTypeKey(e.value)} />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSSelect2 fontSize='0.9em' label="หน่วยงาน" options={ArrDepartment} value={DepartmentKey} onChange={e => setDepartmentKey(e.value)} />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSSelect2 fontSize='0.9em' label="ระดับ" options={ArrUserLevel} value={UserLevelKey} onChange={e => setUserLevelKey(e.value)} />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSCheckBox checked={IsDefault} onChange={e => setIsDefault(!IsDefault) } />{(IsDefault)? <span style={{ color: 'green' }} >เป็นหน่วยงานหลัก </span>  :<span style={{ color: 'red' }}>ไม่ได้เป็นหน่วยงานหลัก </span>  }
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} >

                                                        <Button
                                                            color="primary"
                                                            type="button"
                                                            onClick={newUserDepartment}
                                                            disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                        >
                                                            <h4>เพิ่มหน่วยงาน</h4>
                                                        </Button>

                                                        <Button
                                                            color="primary"
                                                            type="button"
                                                            onClick={() => setToggleType('')}
                                                        >
                                                            <h4>ยกเลิก</h4>
                                                        </Button>

                                                    </Col>

                                                </Grid>
                                            </Col>
                                            <Col xs={12} sm={12} md={2} lg={4}>  &nbsp;  </Col>
                                        </Grid>
                             :
                             <></>
                           }



                           {(toggleType == 'edit')? 
                           
                           <Grid>
                             <Col xs={12} sm={12} md={2} lg={4}> &nbsp; </Col>
                             <Col xs={12} sm={12} md={8} lg={4}> 
                                 <Grid>
                                   <Col xs={12} sm={12} md={12}>
                                     <input type='hidden' value={UserDepartmentKey}></input>
                                     <TSSelect2 fontSize='0.9em' label="ประเภทโครงสร้าง" options={ArrDepartmentType} value={DepartmentTypeKey} onChange={e => setDepartmentTypeKey(e.value) } />
                                   </Col>
                                   <Col xs={12} sm={12} md={12}>
                                     <TSSelect2 fontSize='0.9em'  label="หน่วยงาน" options={ArrDepartment} value={DepartmentKey} onChange={e => setDepartmentKey(e.value) } />
                                   </Col>
                                   <Col xs={12} sm={12} md={12}>
                                     <TSSelect2 fontSize='0.9em'  label="ระดับ" options={ArrUserLevel} value={UserLevelKey} onChange={e => setUserLevelKey(e.value) } />
                                   </Col>
                                   <Col xs={12} sm={12} md={12}>
                                        <TSCheckBox checked={IsDefault} onChange={e => setIsDefault(!IsDefault) } />{(IsDefault)? <span style={{ color: 'green' }} >เป็นหน่วยงานหลัก </span>  :<span style={{ color: 'red' }}>ไม่ได้เป็นหน่วยงานหลัก </span>  }
                                   </Col>
                                   <Col xs={12} sm={12} md={12} >

                                       <Button
                                         color="primary"
                                         type="button"
                                         onClick={editUserDepartment}
                                         disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                       >
                                         <h4>แก้ไข</h4>
                                       </Button>
                                       
                                       <Button
                                         color="danger"
                                         type="button"
                                         onClick={deleteUserDepartment}
                                         disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                       >
                                         <h4>ลบ</h4>
                                       </Button>

                                       <Button
                                                            color="primary"
                                                            type="button"
                                                            onClick={() => setToggleType('')}
                                       >
                                         <h4>ยกเลิก</h4>
                                       </Button>

                                   </Col>

                                 </Grid>
                             </Col>
                             <Col xs={12} sm={12} md={2} lg={4}>  &nbsp;  </Col>
                           </Grid>
                           :                        
                            <></>
                           }

                           {(toggleType == '') ?
                           <Table className={classes.table} aria-label="simple table" >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>ประเภทโครงสร้าง</TableCell>
                                                    <TableCell>หน่วยงาน</TableCell>
                                                    <TableCell>กลุ่มงาน</TableCell>
                                                    <TableCell>กลุ่มภารกิจ</TableCell>
                                                    <TableCell>ระดับ</TableCell>
                                                    <TableCell>หน่วยงานหลัก</TableCell>
                                                    <TableCell style={{ width: 200 }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {UserDept.map((row) => (
                                                    <>
                                                        <TableRow key={1}>
                                                            <TableCell component="th" scope="row">{row.departmentType.name}</TableCell>
                                                            <TableCell component="th" scope="row">{row.department.name}</TableCell>
                                                            <TableCell component="th" scope="row">{row.department.groupWork.name}</TableCell>
                                                            <TableCell component="th" scope="row">{row.department.groupWork.mission.name}</TableCell>
                                                            <TableCell component="th" scope="row">{row.userLevel.name}</TableCell>
                                                            <TableCell component="th" scope="row">{(row.isDefault == true ? 'Y':'N')}</TableCell>
                                                            <TableCell component="th" scope="row">
                                                                <Icon title="แก้ไข" style={{ color: 'blue', cursor: 'pointer', marginRight: 15 }} className="fa fa-edit" onClick={handleUserDepartment(row.userDepartmentKey, row.departmentTypeKey, row.departmentKey, row.userLevelKey, row.userName, row.isDefault)} />
                                                                <Icon title="ลบ" style={{ color: 'red', cursor: 'pointer' }} className="fa fa-trash" onClick={handleDeleteUserDepartmentDirect(row.userDepartmentKey)} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                                <TableRow key={99}>
                                                    <TableCell component="th" scope="row">
                                                        <Button
                                                            style={{ maxWidth: '400px;' }}
                                                            color="success"
                                                            type="button"
                                                            onClick={handleNewUserDepartment(UserName)}
                                                            disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                        >
                                                            <Icon className="fa fa-plus" />
                                                            <h4>เพิ่มหน่วยงาน</h4>
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                           :
                           <></>
                           }

                       </TabPanel>
                       <TabPanel value={tabValue} index={2}>
                        {(toggleEducationType == 'new' || toggleEducationType == 'edit') ?
                          <><Grid>
                          <Col xs={8} sm={6} md={6}>
                          <Label>วันที่เริ่มต้น</Label>
                          <FormGroup
                            style={{
                              padding: "0",
                              marginBottom: "10px",
                              position: "relative" // สำคัญมาก: ให้ icon อ้างอิงตำแหน่งจากกล่องนี้
                            }}
                            className={"input-lg" + (dateFocus ? " input-group-focus" : "")}
                          >
                            {/* Icon calendar แบบ responsive */}
                            <i
                              className="far fa-calendar-check fa-2x"
                              style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                zIndex: 10,
                                color: "#555",
                                pointerEvents: "none"
                              }}
                            ></i>

                            <Datetime
                              value={moment(StartDate).isValid() ? moment(StartDate) : null}
                              renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                              inputProps={{
                                name: "StartDate",
                                placeholder: "วันที่เริ่มต้น",
                                readOnly: "readonly",
                                style: {
                                  fontSize: "1.2em",
                                  borderRadius: 0,
                                  paddingLeft: "50px", // เผื่อพื้นที่ให้ icon
                                  cursor: "pointer",
                                  background: "#ffffff",
                                  color: "#000000"
                                },
                                value: moment(StartDate).isValid()
                                  ? moment(StartDate).format("D MMMM BBBB")
                                  : ""
                              }}
                              closeOnSelect={true}
                              closeOnTab={true}
                              dateFormat="D MMMM BBBB"
                              timeFormat={false}
                              onFocus={() => setDateFocus(true)}
                              onBlur={() => setDateFocus(false)}
                              onChange={(e) => handleStartDate(e.format("YYYY-MM-DD"))}
                              minDate={new Date("02-01-2020")} />
                          </FormGroup>
                        </Col>
                        <Col xs={8} sm={6} md={6}>
                          <Label>วันที่สิ้นสุด</Label>
                          <FormGroup
                            style={{ padding: '0 0px', marginBottom: '10px', position: 'relative' }}
                            className={"input-lg" + (dateFocus ? " input-group-focus" : "")}
                          >
                            {/* Icon อยู่ในกล่อง input แบบ responsive */}
                            <i
                              className="far fa-calendar-check fa-2x"
                              style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                zIndex: 10,
                                color: "#555",
                                pointerEvents: "none"
                              }}
                            ></i>
                            <Datetime
                              value={moment(EndDate).isValid() ? moment(EndDate) : null}
                              renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                              inputProps={{
                                name: "EndDate",
                                placeholder: "วันที่สิ้นสุด",
                                readOnly: 'readonly',
                                style: {
                                  fontSize: '1.2em',
                                  borderRadius: 0,
                                  paddingLeft: '50px', // ขยับให้เว้นที่สำหรับไอคอน
                                  cursor: 'pointer',
                                  background: '#ffffff',
                                  color: '#000000'
                                },
                                value: moment(EndDate).isValid()
                                  ? moment(EndDate).format('D MMMM BBBB')
                                  : ''
                              }}
                              closeOnSelect={true}
                              closeOnTab={true}
                              dateFormat="D MMMM BBBB"
                              timeFormat={false}
                              onFocus={() => setDateFocus(true)}
                              onBlur={() => setDateFocus(false)}
                              onChange={e => handleEndDate(e.format('YYYY-MM-DD'))}
                              minDate={new Date("02-01-2020")} />
                          </FormGroup>
                        </Col>
                      </Grid><Grid>
                          {/* ======== TopicName ======== */}
                          <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                            <TSText
                              label="ชื่อหลักสูตร"
                              value={TopicName}
                              onChange={(e) => setTopicName(e.target.value)} />
                          </Col>
                          {/* ======== OrganizationName ======== */}
                          <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                            <TSText
                              label="หน่วยงานที่จัด"
                              value={OrganizationName}
                              onChange={(e) => setOrganizationName(e.target.value)} />
                          </Col>
                          {/* ======== PlaceName ======== */}
                          <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                            <TSText
                              label="สถานที่"
                              value={PlaceName}
                              onChange={(e) => setPlaceName(e.target.value)} />
                          </Col>
                          {/* ======== DurationNote ======== */}
                          <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                            <TSText
                              label="ระยะเวลา"
                              value={DurationNote}
                              onChange={(e) => setDurationNote(e.target.value)} />
                          </Col>
                          {/* ======== Note (textarea) ======== */}
                          <Col xs={12} sm={12} md={12}>
                            <div className="textarea-container" style={{ padding: 0 }}>
                              <Label for="Note">หมายเหตุ (Note)</Label>
                              <Input
                                id="Note"
                                name="Note"
                                placeholder="หมายเหตุ"
                                rows="4"
                                type="textarea"
                                style={{ fontSize: "1.2em", maxHeight: "150px" }}
                                value={Note}
                                onChange={(e) => setNote(e.target.value)} />
                            </div>
                          </Col>
                          {/* ======== ปุ่มบันทึก ======== */}
                          <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                            {(toggleEducationType == 'new' && <Button
                              style={{ maxWidth: 400 }}
                              color="primary"
                              onClick={saveNewEducation}
                            >
                              <h4>บันทึก</h4>
                            </Button>)}
                            {(toggleEducationType == 'edit' && <><Button
                              color="primary"
                              type="button"
                              onClick={editEducation}
                              disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                            >
                              <h4>แก้ไข</h4>
                            </Button><Button
                              color="danger"
                              type="button"
                              onClick={deleteEducation}
                              disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                            >
                                <h4>ลบ</h4>
                              </Button></>
                            )}
                            <Button
                              color="primary"
                              type="button"
                              onClick={() => setToggleEducationType('')}
                            >
                              <h4>ยกเลิก</h4>
                            </Button>
                          </Col>

                        </Grid></>     
                            :
                            <></>
                           }

                          {(toggleEducationType == '') ?
                           <Table className={classes.table} aria-label="simple table" >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>วันที่เริ่มต้น</TableCell>
                                                    <TableCell>วันที่สิ้นสุด</TableCell>
                                                    <TableCell>ชื่อหลักสูตร</TableCell>
                                                    <TableCell>หน่วยงานที่จัด</TableCell>
                                                    <TableCell>สถานที่</TableCell>
                                                    <TableCell>ระยะเวลา</TableCell>
                                                    <TableCell>หมายเหตุ</TableCell>
                                                    <TableCell style={{ width: 200 }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {UserEducation.map((row) => (
                                                    <>
                                                        <TableRow key={1}>
                                                            <TableCell component="th" scope="row">{row.fromDate ? moment(row.fromDate).format("D MMMM BBBB") : "-"}</TableCell>
                                                            <TableCell component="th" scope="row">{row.toDate ? moment(row.toDate).format("D MMMM BBBB") : "-"}</TableCell>
                                                            <TableCell component="th" scope="row">{row.topicName}</TableCell>
                                                            <TableCell component="th" scope="row">{row.organizationName}</TableCell>
                                                            <TableCell component="th" scope="row">{row.placeName}</TableCell>
                                                            <TableCell component="th" scope="row">{row.durationNote}</TableCell>
                                                            <TableCell component="th" scope="row">{row.note}</TableCell>
                                                            <TableCell component="th" scope="row">
                                                                <Icon style={{ color: 'blue' }} className="fa fa-edit" onClick={handleEditEducation(row.fromDate, row.toDate, row.topicName, row.organizationName, row.placeName, row.durationNote, row.note, row.empEducationOtherKey)} /></TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                                <TableRow key={99}>
                                                    <TableCell component="th" scope="row">
                                                        <Button
                                                            style={{ maxWidth: '400px;' }}
                                                            color="success"
                                                            type="button"
                                                            onClick={handleNewEducation(UserName)}
                                                            disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                        >
                                                            <Icon className="fa fa-plus" />
                                                            <h4>เพิ่ม</h4>
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                          :
                          <></>
                         }

                        
                        </TabPanel>


                       {/* 
                       <TabPanel value={tabValue} index={2}>
                         Item Three
                       </TabPanel>
                       <TabPanel value={tabValue} index={3}>
                         Item Four
                       </TabPanel>
                       <TabPanel value={tabValue} index={4}>
                         Item Five
                       </TabPanel>
                       <TabPanel value={tabValue} index={5}>
                         Item Six
                       </TabPanel>
                       <TabPanel value={tabValue} index={6}>
                         Item Seven
                       </TabPanel>
                       */}
                         
                     </CardBody>
                     
                   <CardFooter>
                       <Collapse isOpen={isOpen}>
                       </Collapse>
                       {/* Confirm */}
                       <Modal toggle={() => setModal(false)} isOpen={modal}>
                         <div className="modal-header justify-content-center">
                           <div>
                             <i
                               className={icon}
                               style={{ color: "blue", fontSize: "2em" }}
                             ></i>
                           </div>
                         </div>
                         <ModalBody>
                           <p
                             style={{
                               textAlign: "center"
                             }}
                           >
                             {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                               ? "ยืนยันการบันทึกข้อมูล"
                               : "กำลังตรวจสอบข้อมูล"}
                           </p>
                           <p> </p>
                         </ModalBody>
                         <div className="modal-footer">
                           <Button
                             color="primary"
                             type="button"
                             onClick={() => setModal(false)}
                           >
                             <h4>ยกเลิก</h4>
                           </Button>

                           <Button
                             color="primary"
                             type="button"
                             onClick={handleConfirm}
                             disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                           >
                             <h4>ยืนยัน</h4>
                           </Button>
                         </div>
                       </Modal>

                       {/* Error */}
                       <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                         <div className="modal-header justify-content-center">
                           <div>
                             <i
                               className="fa fa-times"
                               style={{ color: "red", fontSize: "2em" }}
                             ></i>
                           </div>
                         </div>
                         <ModalBody>
                           <p>ไม่สามารถบันทึกข้อมูลได้</p>
                           <div>{errMsg}</div>
                         </ModalBody>
                         <div className="modal-footer justify-content-center">
                           <Button
                             color="primary"
                             type="button"
                             onClick={() => setModalError(false)}
                           >
                             <h4>ตกลง</h4>
                           </Button>
                         </div>
                       </Modal>
                   </CardFooter>
               </Card>

           </Col>
               :

               <></>
               
               }                   

                






             
           </Grid>
       </div>
   );
}
export default Employee;
